import { useContext } from "react";
import { ModalWindowContext } from "../contexts/ModalWindowProvider";

export default function useModalWindow() {
  const context = useContext(ModalWindowContext);

  if (!context) {
    throw new Error("Please Use ModalWindowProvider in parent component.");
  }

  return context;
}
